<template>
  <div>
    <label class="sr-only" for="region-field">Areas</label>
    <slot />
    <select
      name="region"
      id="region-field"
      v-model="selected"
      class="form-select"
    >
      <option value="">{{ preview }}</option>
      <option value="Apalachicola">Apalachicola</option>
      <option value="Cape San Blas/S. Gulf">Cape San Blas/S. Gulf</option>
      <option value="Carrabelle">Carrabelle</option>
      <option value="East Franklin County">East Franklin County</option>
      <option value="Eastpoint">Eastpoint</option>
      <option value="Mexico/St. Joe Beach">Mexico/St. Joe Beach</option>
      <option value="North Gulf County">North Gulf County</option>
      <option value="Other Counties">Other Counties</option>
      <option value="Port St. Joe">Port St. Joe</option>
      <option value="St. George Island">St. George Island</option>
    </select>
  </div>
</template>

<script>
  export default {
    props: {
      fieldValue: {
        type: String,
        default: ''
      },
      preview: {
        type: String,
        default: ""
      }
    },
    watch: {
      selected(val){
        this.$emit('updated', {
          property: 'region',
          value: val
        })
      }
    },
    data () {
      return {
        selected: null
      }
    },
    mounted() {
      this.selected = this.fieldValue
    }
  }
</script>
